import { cn } from "@paribus/shared-ui";
import type { ReactNode } from "react";

import type { Tone } from "./types";

const TONE_SUBTLE: Record<Tone, string> = {
  neutral: "bg-muted text-secondary-foreground",
  brand: "bg-primary-subtle-hover text-primary-emphasis",
  success: "bg-success-subtle-strong text-success-text",
  info: "bg-info-subtle-strong text-info-text",
  warning: "bg-warning-subtle-strong text-warning-text",
  danger: "bg-destructive-subtle-strong text-destructive-text",
  ai: "bg-ai-subtle-strong text-ai-text",
};

const TONE_OUTLINE: Record<Tone, string> = {
  neutral: "border-border-strong text-muted-foreground",
  brand: "border-primary-border text-primary-emphasis",
  success: "border-success-border text-success-text",
  info: "border-info-border text-info-text",
  warning: "border-warning-border text-warning-text",
  danger: "border-destructive-border text-destructive-text",
  ai: "border-ai-border text-ai-text",
};

export interface BadgeProps {
  tone?: Tone;
  /** pill = states · tag = uppercase 11px metadata */
  shape?: "pill" | "tag";
  variant?: "subtle" | "outline";
  icon?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const Badge = ({
  tone = "neutral",
  shape = "pill",
  variant = "subtle",
  icon,
  className,
  children,
}: BadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 whitespace-nowrap font-struct [&_svg]:size-3",
      shape === "pill"
        ? "rounded-full px-2.5 py-[3px] text-xs"
        : "rounded-sm px-1.5 py-0.5 text-2xs uppercase tracking-micro",
      variant === "subtle" ? TONE_SUBTLE[tone] : cn("border bg-transparent", TONE_OUTLINE[tone]),
      className
    )}
  >
    {icon}
    {children}
  </span>
);
